"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentListerPaginationContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const ListerPagination_1 = require("../../components/lister/ListerPagination");
const ContentSelectors_1 = require("../../redux/content/selectors/ContentSelectors");
const ContentListerPaginationContainer = () => {
    const totalPages = (0, react_redux_1.useSelector)((0, ContentSelectors_1.makeGetContentTotalPages)());
    return (0, jsx_runtime_1.jsx)(ListerPagination_1.ListerPagination, { updateCanonicalLinkElement: false, totalPages: totalPages });
};
exports.ContentListerPaginationContainer = ContentListerPaginationContainer;
